// src/AirLuggage.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AirLuggage_default = createIcon({
  displayName: "AirLuggage",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M4.19 4.2825L11.19 1.1725C11.7 0.9425 12.3 0.9425 12.81 1.1725L19.81 4.2825C20.53 4.6025 21 5.3225 21 6.1125V10.8125C21 16.3625 17.16 21.5525 12 22.8125C6.84 21.5525 3 16.3625 3 10.8125V6.1125C3 5.3225 3.47 4.6025 4.19 4.2825ZM13.25 7.58518H10.75V8.16518H13.25V7.58518ZM13.875 8.16518H14.63L14.64 15.7502H9.36V8.16518H10.125V7.29018C10.1289 7.21015 10.1641 7.13488 10.2231 7.08061C10.282 7.02635 10.3599 6.99745 10.44 7.00018H13.56C13.6401 6.99745 13.718 7.02635 13.7769 7.08061C13.8359 7.13488 13.8711 7.21015 13.875 7.29018V8.16518ZM15.215 15.7502V8.16518H15.75C16.0701 8.15437 16.3815 8.27094 16.6158 8.48932C16.8501 8.70771 16.9883 9.01009 17 9.33018V14.5802C16.9883 14.9007 16.8503 15.2036 16.6161 15.4228C16.3819 15.6419 16.0706 15.7596 15.75 15.7502H15.215ZM8.25 8.16518H8.75V15.7502H8.25C7.9294 15.7596 7.61807 15.6419 7.38391 15.4228C7.14974 15.2036 7.01174 14.9007 7 14.5802V9.33018C7.01173 9.01009 7.1499 8.70771 7.38421 8.48932C7.61853 8.27094 7.92988 8.15437 8.25 8.16518Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  AirLuggage_default
};
